// Fixed timestep physics configuration
export const PHYSICS_HZ = 60;
export const PHYSICS_DT_MS = 1000 / PHYSICS_HZ; // ~16.67ms per tick
const MAX_ACCUMULATED_TIME = PHYSICS_DT_MS * 4; // Prevent spiral of death

// Physics timing state
let accumulator = 0;
let lastPhysicsTime = null;

/**
 * Reset physics timing state. Call when starting/restarting a race.
 */
export function resetPhysicsTiming() {
  accumulator = 0;
  lastPhysicsTime = null;
}

/**
 * Run physics at fixed timestep using accumulator pattern.
 * @param {number} currentTime - Current time in ms (e.g., offsetNow from race start)
 * @param {function} physicsTick - Function to call for each physics tick
 * @returns {number} Number of physics ticks executed
 */
export function runPhysics(currentTime, physicsTick) {
  if (lastPhysicsTime === null) {
    lastPhysicsTime = currentTime;
    return 0;
  }

  let deltaTime = currentTime - lastPhysicsTime;
  lastPhysicsTime = currentTime;

  // Cap accumulated time to prevent spiral of death at very low FPS
  accumulator += Math.min(deltaTime, MAX_ACCUMULATED_TIME);

  let ticksRun = 0;
  while (accumulator >= PHYSICS_DT_MS) {
    physicsTick();
    accumulator -= PHYSICS_DT_MS;
    ticksRun++;
  }

  return ticksRun;
}

/**
 * Get interpolation alpha for smooth rendering between physics ticks.
 * @returns {number} Value between 0 and 1 indicating progress toward next tick
 */
export function getInterpolationAlpha() {
  return accumulator / PHYSICS_DT_MS;
}
